import React from 'react';
import icNext from '../../assets/imgs/ic_top.svg?react';
import styles from './styles.module.css';

const BorderButton = ({ onClick, text }: { onClick: React.MouseEventHandler<HTMLDivElement>; text: string }) => {
    return (
        <div className={styles.borderButton} onClick={onClick}>
            <p className={styles.borderButtonText}>{text}</p>
            <div className={styles.icNextLayout}>{React.createElement(icNext, { className: styles.icNext })}</div>
        </div>
    );
};

export default BorderButton;
